import { Route } from '@angular/router';
import { products } from './products';
import { RoutingID } from '../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const offerings: Route = {
  path: 'offerings',
  title: 'nav.offerings',
  data: {
    icon: SbIcons.offerings,
    breadcrumb: 'nav.offerings',
    id: RoutingID.offerings,
  },
  children: [
    products,
    {
      path: '',
      redirectTo: RoutingID.products,
      pathMatch: 'full',
      /*data: {
        breadcrumb: '',
      },*/
    },
  ],
};
